import { Box } from '@mui/material';
import React, { FC } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { Modal } from 'shared/components/Modal';
import { ModalName } from 'app/enums';
import { TournamentGameActivity } from 'modules/tournament-activity/components/TournamentGameActivity';
import { Bracket } from '../Bracket';

export const FullScreenBracketModal: FC = () => {
  return (
    <Modal
      fullScreen
      withCloseIcon={false}
      isHeaderHighlighted={false}
      isFooterHighlighted={false}
      isHeaderPaddingEnabled={false}
      name={ModalName.FullScreenBracket}
      header={<TournamentGameActivity />}
    >
      <Box display="flex" height="100%">
        <ScrollContainer vertical={true} horizontal={true} hideScrollbars={false}>
          <Bracket />
        </ScrollContainer>
      </Box>
    </Modal>
  );
};
